<div class="max-w-7xl mx-auto px-4 py-12">
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-12 items-stretch mb-16">

    <aside
      class="
      h-full rounded-lg p-8 flex flex-col items-center text-center space-y-8
         shadow-none border-0
         lg:shadow-[0px_0px_56px_0px_rgba(0,38,3,0.08)]
         lg:border lg:border-gray-50">

         <hr class="w-full border-gray-100 lg:hidden">
      <div class="flex flex-col items-center">
        <div class="text-[#2187AB] mb-4">
          <sham-i-location-address class="*:size-10" />
        </div>
        <p class="text-gray-700 font-normal leading-relaxed text-base">
          {{ 'contact.location' | translate }}
        </p>
      </div>

      <hr class="w-full border-gray-100 hidden lg:block">

      <div class="flex flex-col items-center">
        <div class="text-[#2187AB] mb-4">
          <sham-i-mail-01-Stroke class="*:size-10" />
        </div>
        <p class="text-gray-700 text-base font-normal">{{ 'contact.email1' | translate }}</p>
        <p class="text-gray-700 text-base font-normal"> {{ 'contact.email2' | translate }}</p>
      </div>

     <hr class="w-full border-gray-100 hidden lg:block">

      <div class="flex flex-col items-center">
        <div class="text-[#2187AB] mb-4">
          <sham-i-phone-03 class="*:size-10" />
        </div>
        <p class="text-gray-700 text-base font-normal" dir="ltr"> {{ 'contact.phone1' | translate }}</p>
        <p class="text-gray-700 text-base font-normal" dir="ltr"> {{ 'contact.phone2' | translate }}</p>
      </div>

    </aside>

    <main class="lg:col-span-2 flex flex-col justify-center h-full">
      <h2 class="text-2xl font-bold text-gray-900 mb-2"> {{ 'contact.title' | translate }}</h2>
      <p class="text-gray-500 text-sm font-normal mb-4 max-w-2xl">
        {{ 'contact.description' | translate }}
      </p>

      <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="space-y-6">

        <div class="space-y-2">
          <label class="text-sm font-normal text-[#0D3543]"> {{ 'contact.emailLabel' | translate }}</label>
          <div class="relative mt-1">
            <span class="absolute inset-y-0 start-0 flex items-center ps-4 text-[#6C737F]">
              <sham-i-mail-01-Stroke class="*:size-5" />
            </span>
            <input type="email" formControlName="email" [placeholder]="'contact.emailPlaceholder' | translate"
              class="w-full ps-12 pe-4 py-3 text-base font-normal border border-[#BBDEEB] rounded-lg focus:ring-2 focus:ring-blue/20 focus:border-blue outline-none transition-all">
          </div>
        </div>

        <div class="space-y-2">
          <textarea formControlName="subject" [placeholder]="'contact.subjectPlaceholder' | translate" rows="3"
            class="w-full p-4 border border-[#BBDEEB] rounded-lg focus:ring-2 focus:ring-blue/20 focus:border-blue outline-none transition-all resize-none"></textarea>
        </div>

        <button type="submit"
          class="w-full bg-[#2596BE] hover:bg-[#2589aa] text-white font-normal py-3.5 rounded-lg transition-colors shadow-md active:scale-[0.98]">
          {{ 'contact.button' | translate }}
        </button>
      </form>
    </main>
  </div>


</div>

<section class="w-full h-112 overflow-hidden px-4 sm:px-0 pb-12">
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d106429.5441113063!2d36.19114754519968!3d33.51041300994977!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1518e6dc413cc6a7%3A0x6b9f4620ca6057b2!2sDamascus%2C%20Syria!5e0!3m2!1sen!2s!4v1715420000000!5m2!1sen!2s"
    class="w-full h-full border-0" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">
  </iframe>
</section>
